"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function modifyCSS(dom, css) {
    if (dom) {
        for (var key in css) {
            if (css.hasOwnProperty(key)) {
                dom.style[key] = css[key];
            }
        }
    }
    return dom;
}
exports.default = modifyCSS;
//# sourceMappingURL=modify-css.js.map